import React from "react";

interface TraceabilityIconProps {
	fontSize?: "small" | "medium" | "large" | "inherit";
	className?: string;
}

const TraceabilityIcon: React.FC<TraceabilityIconProps> = ({ fontSize = "medium", className = "" }) => {
	const sizeMap = {
		small: "16px",
		medium: "20px",
		large: "24px",
		inherit: "1em",
	};

	return (
		<svg
			width={sizeMap[fontSize]}
			height={sizeMap[fontSize]}
			viewBox="0 0 20 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden>
			<path
				d="M10.6917 0.0544262C10.305 0.221935 10.1583 0.681509 10.3716 1.0423C10.5006 1.26564 10.6739 1.36013 11.0962 1.42885C12.532 1.67367 13.8434 2.24921 14.9369 3.10823C15.3459 3.43036 16.0749 4.16482 16.3638 4.54708C17.3907 5.89574 17.9241 7.36466 17.9908 8.99249C18.0619 10.8351 17.5463 12.4887 16.4349 13.9963C16.0438 14.5246 15.0614 15.4609 14.4702 15.8603C13.9412 16.2211 13.8434 16.3285 13.7989 16.5991C13.7411 16.9899 14.0434 17.3464 14.4657 17.3808C14.7413 17.398 14.9325 17.3121 15.5326 16.8783C18.0352 15.0743 19.471 12.3169 19.471 9.31462C19.471 6.81059 18.4486 4.42682 16.6216 2.66154C15.8437 1.90561 15.0525 1.36013 14.0256 0.874788C13.2566 0.505411 12.5098 0.256296 11.723 0.101673C11.1051 -0.018589 10.8873 -0.0271797 10.6917 0.0544262Z"
				fill="currentColor"
			/>
			<path
				d="M6.37913 0.471033C6.00129 0.59559 5.02333 1.05516 4.5877 1.31716C3.36971 2.04733 2.21395 3.16834 1.45826 4.3409C1.16043 4.80477 0.684789 5.74969 0.653673 5.93867C0.573658 6.42402 1.03152 6.85352 1.53383 6.76333C1.80054 6.71179 1.93834 6.55287 2.26729 5.90861C2.77405 4.89926 3.22746 4.30654 4.06761 3.52484C4.82774 2.82044 5.67234 2.29215 6.74808 1.86264C7.34375 1.62211 7.43265 1.52762 7.45932 1.13247C7.48155 0.814639 7.36597 0.62136 7.06814 0.475327C6.8281 0.35936 6.72141 0.35936 6.37913 0.471033Z"
				fill="currentColor"
			/>
			<path
				d="M0.306721 8.73085C0.0711237 8.88548 0 9.06587 0 9.50397C0 11.4453 0.786806 13.5542 2.12482 15.1907C3.48506 16.8614 5.58766 18.107 7.74804 18.5279C9.02826 18.7771 10.2596 18.7856 11.5309 18.5623C11.8777 18.5022 11.9532 18.4764 12.0999 18.339C12.4155 18.0555 12.42 17.6002 12.1088 17.3167C11.9399 17.1621 11.7354 17.1106 11.4554 17.1449C11.3531 17.1578 11.0508 17.2008 10.7797 17.2351C9.80618 17.3683 8.65931 17.2995 7.65469 17.0461C4.77862 16.3203 2.47599 14.0954 1.73364 11.3251C1.57361 10.7195 1.51138 10.3071 1.47137 9.60705C1.43581 9.00144 1.40025 8.91554 1.11131 8.72227C0.902382 8.58482 0.524537 8.58912 0.306721 8.73085Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default TraceabilityIcon;
